export default "__VITE_ASSET__M8RoxGvu__"